/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для списка форм собственности.
   */
  app.ChoiceOwnershipTypePopupView = app.View.extend({
    el: '.choice-type-of-ownership-popup',
    jsonOwnershipTypes: '#json-ownership-types',
    template: app.helpers.TemplateHelper.getTemplate('#choice-type-of-ownership-template'),
    events: {
      'click .type-of-ownership': 'choiceTypeOfOwnership'
    },

    run: function () {
      this.ownershipTypes = new app.OwnershipTypes();
      this.ownershipTypes.reset(app.helpers.TemplateHelper.getJson(this.jsonOwnershipTypes));
    },

    /**
     * Выбор формы собственности
     * @param e
     */
    choiceTypeOfOwnership: function (e) {
      /**
       * Наименование типа собственности
       */
      var name = $(e.currentTarget).text();
      /**
       * ID типа собственности
       */
      var id = $(e.currentTarget).data('id');

      app.ownershipType.save({id: id, name: name});
      var models = this.ownershipTypes.models;
      this.$el.find('.head-actions').html(this.template({models: models, chosen: id}));
    }
  });
})(jQuery);

}.call(window));